var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"evaluation_big_box"},[_c('img',{staticClass:"evaluation_icon",attrs:{"src":require('@/assets/images/books/book2/evaluation_icon.png'),"alt":""}}),_c('div',{staticClass:"title"},[_vm._v("My Self-Assessment Report")])])}
var staticRenderFns = []

export { render, staticRenderFns }